import { render, staticRenderFns } from "./ActionsOptions.vue?vue&type=template&id=8edf0870&scoped=true"
import script from "./ActionsOptions.vue?vue&type=script&lang=js"
export * from "./ActionsOptions.vue?vue&type=script&lang=js"
import style0 from "./ActionsOptions.vue?vue&type=style&index=0&id=8edf0870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edf0870",
  null
  
)

export default component.exports